import type {
  CreateEgressPolicyRequest,
  DeleteEgressPolicyResponse,
  EffectiveEgressPolicyResponse,
  GetOrgEgressPolicyResponse,
  ListEgressPoliciesResponse,
  MutateEgressPolicyResponse,
  PutOrgEgressPolicyRequest,
  PutOrgEgressPolicyResponse,
  UpdateEgressPolicyRequest,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/egress';

export async function listEgressPolicies(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListEgressPoliciesResponse> {
  return opsApiRequest<ListEgressPoliciesResponse>(`${BASE}/policies`, { signal }, fetchImpl);
}

export async function createEgressPolicy(
  body: CreateEgressPolicyRequest,
  fetchImpl: typeof fetch,
): Promise<MutateEgressPolicyResponse> {
  return opsApiRequest<MutateEgressPolicyResponse>(`${BASE}/policies`, { method: 'POST', body }, fetchImpl);
}

export async function updateEgressPolicy(
  policyId: string,
  body: UpdateEgressPolicyRequest,
  fetchImpl: typeof fetch,
): Promise<MutateEgressPolicyResponse> {
  return opsApiRequest<MutateEgressPolicyResponse>(
    `${BASE}/policies/${encodeURIComponent(policyId)}`,
    { method: 'PUT', body },
    fetchImpl,
  );
}

export async function deleteEgressPolicy(
  policyId: string,
  fetchImpl: typeof fetch,
): Promise<DeleteEgressPolicyResponse> {
  return opsApiRequest<DeleteEgressPolicyResponse>(
    `${BASE}/policies/${encodeURIComponent(policyId)}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}

export async function getOrgEgressPolicy(
  orgId: string,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<GetOrgEgressPolicyResponse> {
  return opsApiRequest<GetOrgEgressPolicyResponse>(
    `${BASE}/orgs/${encodeURIComponent(orgId)}/policy`,
    { signal },
    fetchImpl,
  );
}

export async function putOrgEgressPolicy(
  orgId: string,
  body: PutOrgEgressPolicyRequest,
  fetchImpl: typeof fetch,
): Promise<PutOrgEgressPolicyResponse> {
  return opsApiRequest<PutOrgEgressPolicyResponse>(
    `${BASE}/orgs/${encodeURIComponent(orgId)}/policy`,
    { method: 'PUT', body },
    fetchImpl,
  );
}

export async function getEffectiveEgressPolicy(
  query: { readonly orgId?: string; readonly ingress: string; readonly upstreamId: string },
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<EffectiveEgressPolicyResponse> {
  const params = new URLSearchParams();
  if (query.orgId !== undefined && query.orgId.length > 0) params.set('org_id', query.orgId);
  params.set('ingress', query.ingress);
  params.set('upstream_id', query.upstreamId);
  return opsApiRequest<EffectiveEgressPolicyResponse>(
    `${BASE}/effective?${params.toString()}`,
    { signal },
    fetchImpl,
  );
}
